import { AxiosClient } from '@/app/shared/services';
import { toFormData } from "@/app/shared/services/helpers";

const state = {
  personal_data: {
    profile: {},
  },
};

const getters = {
  PERSONAL_DATA: (state) => state.personal_data,
};

const mutations = {
  SET_PERSONAL_DATA: (state, payload) => {
    console.log('SET_PERSONAL_DATA');
    let type = payload.type;
    if (type === 'profile') {
      console.log('set profile');
      state.personal_data.profile = payload.data;
    } else if (type === 'all') {
      console.log('set all');
      console.log(payload.data);
      state.personal_data.profile = payload.data;
    }
  },
};

const actions = {
  GET_PERSONAL_DATA: (context, type) => {
    return new Promise((resolve, reject) => {
      let params = {
        "type": type
      };

      AxiosClient.get("/profiles/me", { params: params })
        .then((data) => {

          // Создаем новый объект, не мутируем исходный
          const processedData = JSON.parse(JSON.stringify(data.data));

          if (processedData && processedData.full_name) {
            const parts = processedData.full_name.trim().split(/\s+/);
            processedData.second_name = parts[0] || '';
            processedData.name = parts[1] || '';
            processedData.middle_name = parts[2] || '';
          }

          let data_for_set = {
            type: type,
            data: processedData
          };

          console.log('data_for_set: ', data_for_set);

          context.commit("SET_PERSONAL_DATA", data_for_set);
          resolve();
        })
        .catch((error) => {
          console.error('Ошибка получения данных: ', error);
          reject();
        });
    });
  },
  CHANGE_PROFILE_DATA: (context, payload) => {
    return new Promise((resolve, reject) => {
      AxiosClient.post("/profiles/me/profile", payload)
        .then(() => {
          context.dispatch('GET_PERSONAL_DATA', 'profile');
          resolve();
        })
        .catch((error) => {
          console.error('Ошибка получения данных: ', error);
          console.error('Тип ошибки: ', error.response.data.exception);

          reject();
        });
    });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
